import { render, staticRenderFns } from "./ClaimIndicator.vue?vue&type=template&id=56f33472"
import script from "./ClaimIndicator.vue?vue&type=script&lang=ts"
export * from "./ClaimIndicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports